import { get, post, put } from './apiService';

const gameService = {
  getGames: async () => {
    try {
      return await get('admin/getgames', { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to fetch games');
    }
  },
  createGame: async (data) => {
    try {
      return await post('admin/creategame', data, { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to create game');
    }
  },
  updateGame: async (data) => {
    try {
      return await put('admin/updategame', data, { withCredentials: false });
    } catch (err) {
      throw new Error(err.message || 'Failed to update game');
    }
  },
};

export default gameService;
